import React from 'react'
import '../assets/style.css'
import { CalendarDays } from 'lucide-react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import Image from './Image';

const NewsCard = ({ id, picture, name, date, title }) => {
    const eventDate = date ? new Date(date) : null;

    return (
        <>
            <div className="w-full p-4">
                <Link to={`/news/${id}`}>
                    <Image id={picture} className="w-full h-auto newscard-image" />
                </Link>
                <div className="p-2">
                    <p className="newscard-date">
                        <span className="flex items-center gap-2 p-1">
                            <CalendarDays className="w-4 h-4" />
                            {eventDate ? format(eventDate, 'MMMM dd, yyyy') : 'Date not available'}
                        </span>
                    </p>
                    <span className="bg-yellow-200 text-yellow-800 text-sm font-medium mr-2 px-2.5 py-0.9 rounded-md">
                        Uploaded by {name}
                    </span>
                    <p className="newscard-title">
                        <Link to={`/news/${id}`} className="text-sm md:text-xl lg:text-2xl font-semibold">
                            {title}
                        </Link>
                    </p>
                </div>
            </div>

        </>
    )
}

export default NewsCard